module.exports = __webpack_public_path__ + "static/img/PRULIA_BannerSmartPartner.4b9a55d5.jpg";